import { Maybe } from 'types/graphqlTypes'
import DISPLAY from 'constants/display'
import { floatToPercentage } from './shipperHelpers'

type TFormatStyle = 'currency' | 'percent'

export const getFormattedValueString = (
  value: number | string | undefined | null,
  style?: TFormatStyle | undefined,
  maximumFractionDigits?: number | undefined,
  minimumFractionDigits?: number | undefined
) => {
  if (!value) {
    return ''
  }
  const parsedValue = typeof value === 'number' ? value : parseFloat(value)

  const options: Intl.NumberFormatOptions = {}

  if (style) {
    options.style = style
    options.maximumFractionDigits = maximumFractionDigits || 2
    options.maximumFractionDigits = minimumFractionDigits || 0
    if (style === 'currency') {
      options.currency = 'USD'
    }
  }

  const currencyFormatter = Intl.NumberFormat('en-US', options)
  return currencyFormatter.format(parsedValue)
}

export const getPercentageDisplay = (
  value: number | undefined | null,
  isFloat?: boolean | undefined
) => {
  if (!value && value !== 0) return DISPLAY.empty
  if (!isFloat) return `${value}%`
  return `${floatToPercentage(value)}%`
}

export const getFormattedBooleanString = (
  value: Maybe<boolean>,
  amount?: string | number | null
) => {
  if (!value && value !== false) return ''
  return value
    ? `Yes${amount ? ` - ${getFormattedValueString(amount.toString(), 'currency')}` : ''}`
    : 'No'
}

export const validateUrl = (possibleUrl: string) => {
  try {
    const url = new URL(possibleUrl)
    return url.href
  } catch (e) {
    return ''
  }
}

export const getNumberUnitString = (
  number: number | undefined | null,
  unit: string | undefined | null
) => {
  if (!number || !unit) return undefined
  return `${number} ${unit}${number !== 1 ? 's' : ''}`
}
